import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import _imports_0 from '../../../assets/img/warning.png';
const _hoisted_1 = {
  class: "dialog-content"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1);
const _hoisted_3 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createBlock(_component_el_dialog, {
    modelValue: $data.dialogVisible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.dialogVisible = $event),
    title: _ctx.$t('message.Tips'),
    width: "500px",
    top: "35vh",
    "custom-class": "my-dialog withdraw-dialog",
    "close-on-click-modal": false
  }, {
    footer: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
      onClick: $options.confirm,
      type: "primary"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('message.Confirm')), 1)]),
      _: 1
    }, 8, ["onClick"]), _createVNode(_component_el_button, {
      onClick: $options.close
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('message.Cancel')), 1)]),
      _: 1
    }, 8, ["onClick"])])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("p", null, _toDisplayString(_ctx.$t('message.WithdrawPrompt')), 1)])]),
    _: 1
  }, 8, ["modelValue", "title"]);
}